import { Component, OnInit, ViewChild, Input, Pipe, Injectable, PipeTransform } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { PrintService } from '../../../../../../../../src/app/ncs/services/print.service';

import { AppData } from '../../../../../../../../src/app/ncs/models/appdata';
import { ActorService } from '../../../../../../../../src/app/ncs/services/actor.service';
import { NgbModal, NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { ServiceConfigurationInfoPipe } from '../../../../testnurse/service/service.component';
import { HCPService } from '../../../../../../../../src/app/ncs/services/hcp.service';
import * as alertFunctions from '../../../../../../shared/data/sweet-alerts';

import { ServiceCategoryPipe} from '../../../../../../../../src/app/ncs/pipes/actors/actorIdentity.pipes';
import { NGXToastrService } from '../../../../../../../../src/app/shared/services/toastr.service';
import { CustomDateTimeService } from '../../../../../../../../src/app/ncs/services/datetime.service';
import { SpinnerService } from '../../../../../../../../src/app/ncs/services/spinner.service';
import { ApiResponseModel } from '../../../../../../../../src/app/ncs/models/api_response_model';
import { FollicularScansBetweenDateController, FollicularScansBetweenDateRequest, FollicularScanDetailController, FollicularScanDetailRequest, IvfCycleMedicineByCodeController, IvfCycleMedicineByCodeRequest, IvfCycleTestByCodeController, IvfCycleTestByCodeRequest, FollicularScanOvaryDetailController, FollicularScanOvaryDetailRequest, BillItemsByChargeEntryCodeController, BillItemsByChargeEntryCodeRequest, X_BillHeaderController, x_BillDetailsRequest, BillDetailsInfoController, X_BillItemsController, X_BillReceiptsController, PatientInfoByFormattedCodeController, PatientInfoByFormattedCodeRequest, FacilityDetailInfoController, FacilityDetailInfoRequest } from '../../../../../../../../src/app/ncs/models/actor/actor';



@Pipe({
  name: 'amountToWord'
})
export class AmountToWordPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if (value) {
      value = parseFloat(value).toFixed(2);
      let amounth = value.toString().split(".");
      let price: any = amounth[0];
      let pointer: any = amounth.length > 0 ? amounth[1] : null;
      var singleDigit = ["Zero", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine"],
        doubleDigit = ["Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"],
        tensPlace = ["", "Ten", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"],
        handle_tens = function (digit: any, prevdigit: any) {
          return 0 == digit ? "" : " " + (1 == digit ? doubleDigit[prevdigit] : tensPlace[digit])
        },
        handle_utlc = function (digit: any, nextdigit: any, denom: any) {
          return (0 != digit && 1 != nextdigit ? " " + singleDigit[digit] : "") + (0 != nextdigit || digit > 0 ? " " + denom : "")
        };

      var rupees = "",
        digitIndex = 0,
        digit = 0,
        nextDigit = 0,
        words = [],
        paisaWords = [],
        paisa = "";
      if (price += "", isNaN(parseFloat(price))) rupees = "";
      else if (parseFloat(price) > 0 && price.length <= 10) {
        for (digitIndex = price.length - 1; digitIndex >= 0; digitIndex--)
          switch (digit = price[digitIndex] - 0, nextDigit = digitIndex > 0 ? price[digitIndex - 1] - 0 : 0, price.length - digitIndex - 1) {
            case 0:
              words.push(handle_utlc(digit, nextDigit, ""));
              break;
            case 1:
              words.push(handle_tens(digit, price[digitIndex + 1]));
              break;
            case 2:
              words.push(0 != digit ? " " + singleDigit[digit] + " Hundred" + (0 != price[digitIndex + 1] && 0 != price[digitIndex + 2] ? " and" : "") : "");
              break;
            case 3:
              words.push(handle_utlc(digit, nextDigit, "Thousand"));
              break;
            case 4:
              words.push(handle_tens(digit, price[digitIndex + 1]));
              break;
            case 5:
              words.push(handle_utlc(digit, nextDigit, "Lakh"));
              break;
            case 6:
              words.push(handle_tens(digit, price[digitIndex + 1]));
              break;
            case 7:
              words.push(handle_utlc(digit, nextDigit, "Crore"));
              break;
            case 8:
              words.push(handle_tens(digit, price[digitIndex + 1]));
              break;
            case 9:
              words.push(0 != digit ? " " + singleDigit[digit] + " Hundred" + (0 != price[digitIndex + 1] || 0 != price[digitIndex + 2] ? " and" : " Crore") : "")
          }
        rupees = words.reverse().join("")
      } else rupees = "";

      if (rupees)
        rupees = `${rupees} Rupees`

      if (pointer != "00") {
        digitIndex = 0;
        digit = 0;
        nextDigit = 0;

        for (digitIndex = pointer.length - 1; digitIndex >= 0; digitIndex--)
          switch (digit = pointer[digitIndex] - 0, nextDigit = digitIndex > 0 ? pointer[digitIndex - 1] - 0 : 0, pointer.length - digitIndex - 1) {
            case 0:
              paisaWords.push(handle_utlc(digit, nextDigit, ""));
              break;
            case 1:
              paisaWords.push(handle_tens(digit, pointer[digitIndex + 1]));
              break;
          }
        paisa = paisaWords.reverse().join("");
        if (rupees)
          rupees = `${rupees} and ${paisa} Paisa`
        else
          rupees = `${paisa} Paisa`
      }
      return rupees
    }
  }
}

@Component({
  selector: 'A5rxbill',
  templateUrl: './A5rxbill.component.html',
  styleUrls: ['./A5rxbill.component.scss']
})

export class A5RxbillComponent implements OnInit {

  public ApiResData: ApiResponseModel;
  public isRequesting: boolean = false;

  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  public RXlogo: string = "";
  public RXHeaderLine1: string = "";
  public RXHeaderLine2: string = "";
  public Date: Date;
  public PatientId: string;
  public ChargeEntry: any;
  public PatientName: string;
  public PayeeName: string;
  public Toatalbill: number;
  public PaidBill: number;
  public ReceiptFormattedCode: string;
  public Owner: string;
  public Gender: string;
  public Age: string;
  public BillDate: string;
  public BillNo: string;
  public Branch: string;
  public GrandTotal: any;
  public Discount: any;
  public Tax: any;
  public Net: any;
  public Due: any;
  public DiscountSum: number;
  public FormattedCode: string;
  public GST: string;
  public DL: string;
  public Branchname: string;
  public PrintlogoWidth: number;
  public PrintlogoHeight: number;
  public PrintlogoBorderRadius: number;

  public RXHeaderSubTitle1: string = "";
  public RXHeaderSubTitle2: string = "";
  public RXHeaderSubTitle1Value: string = "";
  public RXHeaderSubTitle2Value: string = "";

  RXBillTitle: string = "Pharmacy Bill";
  RXDotMatrixPrint: string = "false";
  RXLaserPrint: string = "true";
  RXITEMCOLS: string[];
  RXFontFamily: string = "";
  RXFontSize: number;
  RXPrintBodyWithPatientDetails: string = "false";

  ShowRXPrintHeaderLogoCustomer: string = "true";
  ShowRXPrintHeaderLogo: string = "false";
  RXPrintHeaderHeight: number = 165;
  RXPrintHeaderEmpty: string = "false";
  ShowRXPrintFooter: string = "true";
  ShowRXPrintFooterEmpty: string = "false";
  RXPrintFooterHeight: number = 150;
  DmFont: string = "normal normal 12px courier, arial";
  RXDmFont: string = "normal normal 14px Sans Serif, Script";


  CurrentX_BillHeaderController: X_BillHeaderController;
  //FollicularScanEndInfo: FollicularScanDetailController;
  // BillHeader: X_BillHeaderController[];
  CurrentX_BillHeaderRequest: x_BillDetailsRequest;
  BillDataHeader: BillDetailsInfoController;

  LoadBillHeader() {
    //alert("ScansData")
    this.CurrentX_BillHeaderRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
    this.CurrentX_BillHeaderRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillHeaderController();
  }

  GetX_BillHeaderController() {
    //this.StartRefreshing();

    this.CurrentX_BillHeaderRequest.ChargeEntry = this.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillHeaderRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillHeaderController(this.CurrentX_BillHeaderRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
          this.BillDataHeader = this.ApiResData.Result;
          this.CurrentX_BillHeaderController = this.BillDataHeader.Header;       
          //alert(this.CurrentX_BillHeaderController[0].PatientName);
          //this.CurrentX_BillHeaderController = this.BillDataHeader.Header;
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadBillItems();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentX_BillItemsController: X_BillItemsController[];
  //FollicularScanEndInfo: FollicularScanDetailController;
  //BillHeader: X_BillHeaderController[];
  CurrentX_BillItemsRequest: x_BillDetailsRequest;

  BillData: BillDetailsInfoController;
  BillData2: X_BillItemsController;

  LoadBillItems() {
    //alert("ScansData")
    this.CurrentX_BillItemsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
    this.CurrentX_BillItemsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillItemsController();
  }

  GetX_BillItemsController() {
    //this.StartRefreshing();

    this.CurrentX_BillItemsRequest.ChargeEntry = this.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillItemsRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillItemsController(this.CurrentX_BillItemsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillData = this.ApiResData.Result;
          this.CurrentX_BillItemsController = this.BillData.Items;
          this.BillData2 = this.CurrentX_BillItemsController[0];
          this.DiscountSum = this.CurrentX_BillItemsController.filter(l => l.Discount)
            .reduce((sum, current) => sum + current.Discount, 0);
          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadBillReceipts();
          //   this.LoadGuardian();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentX_BillReceiptsController: X_BillReceiptsController[];

  CurrentX_BillReceiptsRequest: x_BillDetailsRequest;

  BillDataReceipt: BillDetailsInfoController;

  LoadBillReceipts() {
    //alert("ScansData")
    this.CurrentX_BillReceiptsRequest = new x_BillDetailsRequest();
    //this.CurrentFollicularScansBetweenDateController = new Array<FdActorReportsDocController>();
    //this.CurrentPatientInfoByFormattedCodeController = new PatientInfoByFormattedCodeController[0];
    //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();
    this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
    this.CurrentX_BillReceiptsRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetX_BillReceiptsController();
  }

  GetX_BillReceiptsController() {
    //this.StartRefreshing();

    this.CurrentX_BillReceiptsRequest.ChargeEntry = this.ChargeEntry;
    // alert(this.SelectedpatientDetails[0].Header[0].ChargeEntry);
    this.CurrentX_BillReceiptsRequest.ConditionalOperator = 5;
    //this.Cu
    //alert(this.FormattedCode);

    this.actorservice.GetBillReceiptsController(this.CurrentX_BillReceiptsRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode.toString();

          this.BillDataReceipt = this.ApiResData.Result;
          this.CurrentX_BillReceiptsController = this.BillDataReceipt.Receipts;
          this.PatientName = this.CurrentX_BillReceiptsController[0].PatientName;
          this.PayeeName = this.CurrentX_BillReceiptsController[0].PayeeName;
          this.Toatalbill = this.CurrentX_BillReceiptsController[0].AmountPayable;
          this.PaidBill = this.CurrentX_BillReceiptsController[0].AmountPaid;



          // this.CurrentX_BillHeaderController[0].PatientName;
          //alert(this.CurrentX_BillHeaderController);
          //this.BillHeader = this.CurrentX_BillHeaderController[0].PatientName;
          //this.CurrentSaveFollicularScanDetailRequest.EndometriumThickness
          //  = this.FollicularScanEndInfo.EndometriumThickness;
          //this.CurrentSaveFollicularScanDetailRequest.Remarks = this.FollicularScanEndInfo.Comments;
          //this.CurrentSaveFollicularScanDetailRequest.ScanDate = this.FollicularScanEndInfo.ScanDate;

          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController[0];

          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

          this.stopRefreshing();
          this.LoadBills();
          //this.LoadMessages();


        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentPatientInfoByFormattedCodeController: PatientInfoByFormattedCodeController[];
  SelectedPatientFormattedCode: PatientInfoByFormattedCodeController;
  CurrentPatientInfoByFormattedCodeRequest: PatientInfoByFormattedCodeRequest;



  LoadPatients() {
    this.CurrentPatientInfoByFormattedCodeRequest = new PatientInfoByFormattedCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentPatientInfoByFormattedCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.FormattedCode = this.route.snapshot.paramMap.get('PatientId');
    this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.FormattedCode;

    this.CurrentPatientInfoByFormattedCodeRequest.Branch = 0;
    this.CurrentPatientInfoByFormattedCodeRequest.ConditionalOperator = 10;
    this.CurrentPatientInfoByFormattedCodeRequest.FromDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.ToDate = new Date();
    this.CurrentPatientInfoByFormattedCodeRequest.IsToday = true;
    this.CurrentPatientInfoByFormattedCodeRequest.IsDuration = false;
    this.CurrentPatientInfoByFormattedCodeRequest.SearchText = "";
    this.GetPatientInfoByFormattedCodeController();
  }
  GetPatientInfoByFormattedCodeController() {
    this.StartRefreshing();


    this.actorservice.GetPatientInfoByFormattedCodeController(this.CurrentPatientInfoByFormattedCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentPatientInfoByFormattedCodeController = this.ApiResData.Result;
          this.SelectedPatientFormattedCode = this.CurrentPatientInfoByFormattedCodeController[0];
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  CurrentBillItemsByChargeEntryCodeController: BillItemsByChargeEntryCodeController[];
  CurrentBillItemsByChargeEntryCodeRequest: BillItemsByChargeEntryCodeRequest;



  LoadBills() {
    this.CurrentBillItemsByChargeEntryCodeRequest = new BillItemsByChargeEntryCodeRequest();

    //alert('Checking Forma ' + this.FormattedCode);



    this.CurrentBillItemsByChargeEntryCodeRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.CurrentBillItemsByChargeEntryCodeRequest.ChargeEntryCode = 10074;
    this.CurrentBillItemsByChargeEntryCodeRequest.ConditionalOperator = 10;
    this.GetBillItemsByChargeEntryCodeController();
  }
  GetBillItemsByChargeEntryCodeController() {
    this.StartRefreshing();


    this.actorservice.GetBillItemsByChargeEntryCodeController(this.CurrentBillItemsByChargeEntryCodeRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentBillItemsByChargeEntryCodeController = this.ApiResData.Result;
          //alert(this.CurrentPatientInfoByFormattedCodeController[0].FormattedCode);
          //  this.SelectedService = this.CurrentServiceDetailsByCodeController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentPatientInfoByFormattedCodeRequest.FormattedCode = this.ActorCode.toString();
          this.stopRefreshing();
          this.printService.onDataReady()
          //this.LoadPatientCounsellingPlansIfAny();



        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }
  CurrentFacilityDetailInfoController: FacilityDetailInfoController[];
  CurrentFacilityDetailInfoRequest: FacilityDetailInfoRequest;
  LoadFacility() {
    this.CurrentFacilityDetailInfoRequest = new FacilityDetailInfoRequest();
    this.CurrentFacilityDetailInfoRequest.FacilityCode = AppData.Instance().SelectedBranchCode;
    this.CurrentFacilityDetailInfoRequest.SendApiRequestModel = AppData.Instance().ApiRequestParms;
    this.GetFacilityDetailInfoController();
  }
  //SelectedPatientEmergencyDetails: ActorContactInfoController;
  GetFacilityDetailInfoController() {
    this.StartRefreshing();
    //alert("LOading guarding adata");
    //alert(this.CurrentGuardianInfoRequest.ActorCode);

    this.actorservice.GetFacilityDetailInfoController(this.CurrentFacilityDetailInfoRequest)
      .subscribe((result) => {
        this.ApiResData = result;
        if (!this.ApiResData.hasError) {

          this.CurrentFacilityDetailInfoController = this.ApiResData.Result;
          //this.SelectedPatient = this.CurrentPatientInfoByFormattedCodeController;

          //this.SelectedPatientEmergencyDetails = this.CurrentActorContactInfoController[0];
          //alert(this.CurrentServiceDetailsByCodeController[0].CategoryName);
          //this.CurrentServiceDetailsByCodeRequest.ServiceCode = this.ServiceCode;
          this.stopRefreshing();

        }
        else {
          this.stopRefreshing();
          if (this.ApiResData.ErrorData != "") {

            alertFunctions.AlertParamEr(this.ApiResData.ErrorData);
          }
          else {
            alertFunctions.ShowMessage('Internal Issues', 'Transaction Failed Due to Internal Error.... Please Contact Admin..', 'error');
          }
        }

      },


        (error) => {

          if (error == "401 - Unauthorized") {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();



          }
          else {
            alertFunctions.AlertParamEr(error);
            this.stopRefreshing();
          }
        }


      );
  }

  constructor(private router: Router,
    private actorservice: ActorService,
    private route: ActivatedRoute, private hcpservice: HCPService, private loaderService: SpinnerService,
    private modalService: NgbModal, private filter: ServiceConfigurationInfoPipe, private filter2: ServiceCategoryPipe, private customdatetimeservice: CustomDateTimeService,
    private parserFormatter: NgbDateParserFormatter, private tosterservice: NGXToastrService,

    public printService: PrintService) {


  }


  ngOnInit() {
    this.RXlogo = AppData.Instance().cas.RXlogo;
    this.PrintlogoWidth = AppData.Instance().cas.PrintlogoWidth;
    this.PrintlogoHeight = AppData.Instance().cas.PrintlogoHeight;
    this.PrintlogoBorderRadius = AppData.Instance().cas.PrintlogoBorderRadius;
    this.RXHeaderLine1 = AppData.Instance().cas.RXHeaderLine1;
    this.RXHeaderLine2 = AppData.Instance().cas.RXHeaderLine2;

    this.RXBillTitle = AppData.Instance().cas.RXBillTitle;
    this.RXDotMatrixPrint = AppData.Instance().cas.RXDotMatrixPrint;
    this.RXLaserPrint = AppData.Instance().cas.RXLaserPrint;
    this.RXITEMCOLS = AppData.Instance().cas.RXITEMCOLS.split(",");
    this.RXFontFamily = AppData.Instance().cas.RXFontFamily;
    this.RXFontSize = AppData.Instance().cas.RXFontSize;

    this.RXPrintBodyWithPatientDetails = AppData.Instance().cas.RXPrintBodyWithPatientDetails;

    this.ShowRXPrintHeaderLogoCustomer = AppData.Instance().cas.ShowRXPrintHeaderLogoCustomer;
    this.ShowRXPrintHeaderLogo = AppData.Instance().cas.ShowRXPrintHeaderLogo;
    this.RXPrintHeaderHeight = AppData.Instance().cas.RXPrintHeaderHeight;
    this.RXPrintHeaderEmpty = AppData.Instance().cas.RXPrintHeaderEmpty;
    this.ShowRXPrintFooter = AppData.Instance().cas.ShowRXPrintFooter;
    this.ShowRXPrintFooterEmpty = AppData.Instance().cas.ShowRXPrintFooterEmpty;
    this.RXPrintFooterHeight = AppData.Instance().cas.RXPrintFooterHeight;
    this.DmFont = AppData.Instance().cas.DmFont;
    this.RXDmFont = AppData.Instance().cas.RXDmFont;

    this.Date = new Date();
    this.LoadBillHeader();
    this.LoadPatients();
    this.LoadFacility(); 
    this.GST = AppData.Instance().GetDataParam('TinNo');
    this.DL = AppData.Instance().GetDataParam('DrugLicenceNo');
    this.RXHeaderSubTitle1 = AppData.Instance().cas.RXHeaderSubTitle1;
    this.RXHeaderSubTitle2 = AppData.Instance().cas.RXHeaderSubTitle2;
    this.RXHeaderSubTitle1Value = AppData.Instance().cas.RXHeaderSubTitle1Value;
    this.RXHeaderSubTitle2Value = AppData.Instance().cas.RXHeaderSubTitle2Value;
    this.ChargeEntry = this.route.snapshot.paramMap.get('ChargeEntryData');
    this.PatientId = this.route.snapshot.paramMap.get('PatientId');
    this.ReceiptFormattedCode = this.route.snapshot.paramMap.get('ReceiptFormattedCode');
    this.Owner = this.route.snapshot.paramMap.get('Owner');
    this.Gender = this.route.snapshot.paramMap.get('Gender');
    this.Age = this.route.snapshot.paramMap.get('Age');
    this.BillDate = this.route.snapshot.paramMap.get('BillDate');
    this.BillNo = this.route.snapshot.paramMap.get('BillNo');
    this.Branch = this.route.snapshot.paramMap.get('Branch');
    this.GrandTotal = this.route.snapshot.paramMap.get('GrandTotal');
    this.Discount = this.route.snapshot.paramMap.get('Discount');
    this.Tax = this.route.snapshot.paramMap.get('Tax');
    this.Net = this.route.snapshot.paramMap.get('Net');
    this.Due = this.route.snapshot.paramMap.get('Due');
    this.Branchname = AppData.Instance().SelectedBranchName;
  }

  private stopRefreshing() {
    this.loaderService.displayLoader(false);
    this.isRequesting = false;
  }
  private StartRefreshing() {
    this.loaderService.displayLoader(true);
    this.isRequesting = true;
  }

}








